/** Turn Firebase/network error codes into sentences a human can act on. */
export function friendly(e: unknown): string {
  const err = e as { code?: string; message?: string }
  const code = err?.code ?? ''
  const M: Record<string, string> = {
    'auth/popup-blocked': 'Your browser blocked the sign-in window. Allow popups for this site and try again — or use "Continue with email" instead.',
    'auth/popup-closed-by-user': 'The sign-in window was closed before finishing. No problem — try again whenever you like.',
    'auth/cancelled-popup-request': 'The sign-in window was closed before finishing. Try again whenever you like.',
    'auth/network-request-failed': "Couldn't reach the internet. Check your connection and try again.",
    'auth/too-many-requests': 'Too many attempts in a row — give it a minute, then try again.',
    'auth/invalid-email': "That doesn't look like an email address — check it and try again.",
    'auth/user-disabled': 'This account has been disabled. Contact us if that seems wrong.',
    'auth/operation-not-allowed': "That sign-in method isn't switched on right now. Try the other option.",
    'auth/unauthorized-domain': "Sign-in isn't allowed from this address. If you're on the real site, contact us.",
    'auth/account-exists-with-different-credential': 'You already have an account with this email via a different sign-in method. Try the other option.',
    'auth/invalid-action-code': 'That sign-in link has expired or was already used. Request a fresh one.',
    'auth/expired-action-code': 'That sign-in link has expired. Request a fresh one.',
    'auth/quota-exceeded': 'Sign-in is briefly overloaded — try again in a minute.',
    'auth/web-storage-unsupported': 'Your browser is blocking site storage (private mode?). Sign-in needs it — try a normal window.',
    'functions/unavailable': "Couldn't reach the server. Check your connection and try again.",
    'functions/not-found': "That feature isn't switched on yet — try again later.",
    'functions/internal': 'Something went wrong on our side. Try again in a moment.',
    'unavailable': "Couldn't reach the server. Check your connection and try again.",
    'permission-denied': "You don't have permission to do that. Try signing in again.",
    'deadline-exceeded': 'That took too long — check your connection and try again.',
  }
  if (code && M[code]) return M[code]
  const msg = err?.message ?? String(e)
  // never surface raw "Firebase: Error (auth/...)" strings
  if (/firebase|auth\/|firestore/i.test(msg)) return 'Something went wrong. Try again in a moment.'
  return msg
}
